import { render } from "./MerchantOperatorForm.vue?vue&type=template&id=526aa486&ts=true"
import script from "./MerchantOperatorForm.vue?vue&type=script&lang=ts"
export * from "./MerchantOperatorForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__